import ReactDOM from "react-dom/client";
import App from "./App";

import "antd/dist/reset.css"; // lowest priority
import "./assets/styles/style.css"; // higher priority
import "./assets/styles/responsive.css"; // highest priority

import { Provider } from "react-redux";
import { store } from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
